import { sendSupervisionValidationEmails } from '../../utils/sendSupervisionValidationEmails';

/**
 * Confirms the pensioner for a supervision.
 * @async
 * @function
 *
 * @param {Object} options - The options for confirming the pensioner.
 * @param {Function} options.dispatchAPI - The dispatchAPI function for making API requests.
 * @param {Object} options.supervision - The supervision object.
 * @param {Function} options.setRefreshData - The function to set the refresh data flag.
 * @param {Function} options.message - The function to display a message.
 * @param {boolean} options.refreshData - The flag to refresh the data.
 * @param {Function} options.t - The translation function.
 * @param {Function} options.setOpenModal - The function to set the open modal flag.
 * @returns {Promise<void>} - A promise that resolves when the pensioner is confirmed.
 */
export const confirmPensioner = async ({
  dispatchAPI,
  supervision,
  setRefreshData,
  message,
  refreshData,
  t,
  setOpenModal
}) => {
  setOpenModal(true);
  try {
    await dispatchAPI('PATCH', {
      url: `supervisions/${supervision._id}/status`,
      body: { status: 'BOOKED' }
    });

    await sendSupervisionValidationEmails({
      supervision,
      dispatchAPI,
      message,
      t
    });

    supervision.pensioners.map(async (pensionerData) => {
      await dispatchAPI('PATCH', {
        url: `pensioners/${pensionerData._id}`,
        body: { is_in_supervision: true }
      });
    });

    await dispatchAPI('POST', {
      url: `/customerinvoices/form/${supervision._id}`
    });

    setRefreshData(!refreshData);
    setOpenModal(false);
  } catch (error) {
    setOpenModal(false);
    message(error);
  }
};
